import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

import { Icon } from '@verantos-dev/shared-components';

export const CohortOwner = ({ firstName, lastName }: { firstName?: string; lastName?: string }) => {
  const intl = useIntl();
  const theme = useTheme();

  const userName =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : intl.formatMessage({
          id: 'projects.cohortBuilderPage.components.cohortInfoBar.unknownOwner',
        });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mr: theme.spacing(5),
      }}
    >
      <Box sx={{ display: 'flex', marginRight: `${theme.spacing(1)}` }}>
        <Icon
          id={'cohort-info-bar-owner-icon'}
          icon={'owner'}
          width={16}
          height={16}
          sx={{ fill: '#666' }}
        />
      </Box>
      <Typography variant="body2">
        {intl.formatMessage({
          id: 'projects.cohortBuilderPage.components.cohortInfoBar.labelOwner',
        })}
        :&nbsp;
      </Typography>
      <Typography variant="body2" color={`${theme.palette.text.primary}`}>
        {userName}
      </Typography>
    </Box>
  );
};
